import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Injectable, ViewEncapsulation, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import { QnSbnDataServiceService } from '../../services/qn-sbn-data-service.service';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { CommonModule, formatDate } from '@angular/common';
import { CreateReminderDialogService } from './create-reminder-dialog.service';
import { ReminderTableComponent } from './reminder-table/reminder-table.component';
import { ReminderMessageTempleteDialogComponent } from './create-reminder/reminder-message-templete-dialog/reminder-message-templete-dialog.component';
import { snackbarService } from '@one/web-components';
import { AppUtils } from '../../utlis/app-utils';

export const PICK_FORMATS = {
  parse: { dateInput: { month: 'short', year: 'numeric', day: 'numeric' } },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' }
  }
}

@Component({
  selector: 'dl-due-date-reminder',
  standalone: true,
  imports: [OneWebComponentsAngularModule, ReminderTableComponent, CommonModule, ReactiveFormsModule, FormsModule, ReminderMessageTempleteDialogComponent],
  templateUrl: './due-date-reminder.component.html',
  styleUrl: './due-date-reminder.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DueDateReminderComponent implements OnInit, OnChanges {

  @Input() dialogData?: any; // Optional - only used when component is in modal mode
  @Output() closeDialog = new EventEmitter<any>(); // Optional - only used when component is in modal mode

  reminderVisible: any;
  dateFormate: string;
  public constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private createReminderDialogService: CreateReminderDialogService,
    private _QnSbnDataService: QnSbnDataServiceService,
    private qnsbnservice: QnSbnService,
    private appUtils: AppUtils
  ) {
    this._QnSbnDataService.DueDateEnabled$.subscribe(
      res => {
        this.DueDateEnabled = res;
      }
    )
    this._QnSbnDataService.FeedbackEnabled$.subscribe(
      res => {
        this.feedbackEnabled = res;
      }
    )
  }

  public remindersColumn = ['reminderDate', 'reminderSubject', 'reminderMessage', 'reminderSendMode', 'reminderActionIcons'];
  public remindersData = [];
  public DueDateEnabled: boolean;
  public feedbackEnabled: boolean;
  public feedbackDueDate = new FormControl<Date | null>(null); // Initialize with null, not a date
  public notificationData: any;
  public addMoreReminders: Subject<any> = new Subject<any>();
  public data: {
    tableData: any[],
    columnData: string[],
    feedbackDueDate: Date | null,
    spinnerBool: boolean,
    existingReminders?: any[],
    notificationData?: any
  } = {
      tableData: [],
      columnData: [],
      feedbackDueDate: null, // Don't initialize with current date
      spinnerBool: false,
      existingReminders: []
    }

  public feedbackDueDateFilter = (d: Date | null): boolean => {
    const startDate = d || new Date();
    return startDate <= new Date();
  }

  public setDateFilter(value: number): void {
    const nextDueDate = new Date();
    nextDueDate.setDate(nextDueDate.getDate() + value);
    this.feedbackDueDate.setValue(nextDueDate);
  }

  public ngOnChanges(changes: SimpleChanges): void {

    if (changes['dialogData'] && changes['dialogData'].currentValue && this.dialogData) {
      this.initializeFromDialogData(changes['dialogData'].currentValue);
    }
  }

  private initializeFromDialogData(data: any): void {
    if (data) {
      // Set due date from dialog data
      if (data.feedbackDueDate) {
        this.feedbackDueDate.setValue(new Date(data.feedbackDueDate));
      }

      // Set reminders from dialog data
      if (data.reminders && Array.isArray(data.reminders)) {
        this.remindersData = data.reminders;
        this.addMoreReminders.next(this.remindersData);
      }

      // Set other properties
      if (data.dueDateEnabled !== undefined) {
        this.DueDateEnabled = data.dueDateEnabled;
      }

      if (data.feedbackEnabled !== undefined) {
        this.feedbackEnabled = data.feedbackEnabled;
      }

      if (data.notificationData) {
        this.notificationData = data.notificationData;
      }
    }
  }

  public ngOnInit(): void {
    this.createReminderDialogService.setRemindersDate([]);

   
    if (this.dialogData) {
      this.initializeFromDialogData(this.dialogData);
    }

    
    this._QnSbnDataService.mappingData$.subscribe(observer => {
      if (!this.dialogData) {
        
        if (!this._QnSbnDataService.isEmpty(observer['feedbackDueDate'])) {
          const dueDateValue = observer['feedbackDueDate']['feedbackDueDate'];
         

          if (dueDateValue) {

            let dateToSet: Date | null = null;

            if (dueDateValue instanceof Date) {
              dateToSet = dueDateValue;
            } else if (typeof dueDateValue === 'string') {
              dateToSet = new Date(dueDateValue);

              if (isNaN(dateToSet.getTime())) {

                dateToSet = null;
              }
            }

            if (dateToSet && !isNaN(dateToSet.getTime())) {

              this.feedbackDueDate.setValue(dateToSet, { emitEvent: false });

            }
          }
        }

        // Handle reminders
        if (!this._QnSbnDataService.isEmpty(observer['notificationReminders'])) {
          this.remindersData = observer['notificationReminders']['remindersData'];
          this.addMoreReminders.next(this.remindersData);
        }

        this.changeDetectorRef.detectChanges();
      }
      this.notificationData = observer['localNotificationId'];
    });
  }

  ngOnDestroy(): void {
    this.addProduct(this.feedbackDueDate.value, this.remindersData);
  }

  public getFeedbackDueDate(fdd: Date): void {

    if (!fdd) {
      return;
    }

    this.dateFormate = this.appUtils.formatDateString(fdd);


    this._QnSbnDataService.getMappedQnsbnData({
      "feedbackDueDate": this.dateFormate
    }, "FeedbackDueDate");


    this.changeDetectorRef.detectChanges();
  }

  public addProduct(newDate, reminderData) {
    this._QnSbnDataService.getMappedQnsbnData({
      "feedbackDueDate": newDate
    }, "FeedbackDueDate");
    this._QnSbnDataService.getMappedQnsbnData({
      "remindersData": reminderData
    }, "NotificationReminders");
  }

  public openReminderTemplateDialog(): void {
    this.qnsbnservice.getReminderTemplate(this.notificationData?.Type, this.notificationData?.LocalNotificationLanguage).subscribe(
      (data: any) => {


        this.reminderVisible = true;
        if (data.errorMessage) {
          this.snackBarMessage('alarm', data.errorMessage.errorMessage);
        } else {
          this.displayRemainderTemplateDialog(data.MessageTemplates);
        }
      },
      (error: HttpErrorResponse) => {
        this.qnsbnservice.httpErrorHandler(error, 'Could not fetch message templates.');
      }
    );
  }

  public displayRemainderTemplateDialog(tempData) {


    this.reminderVisible = true;
    const tableColumnData = ['dragHandle', 'selectText', 'messageTemplate', 'iconSets'];
    this.data = {
      tableData: tempData,
      columnData: tableColumnData,
      feedbackDueDate: this.feedbackDueDate.value,
      spinnerBool: true,
      existingReminders: this.remindersData,
      notificationData: this.notificationData
    };

    this.changeDetectorRef.detectChanges();

  }

  public onReminderDialogClose(event: any): void {
    this.reminderVisible = false;

    if (!event?.data) {


      this.addMoreReminders.next(this.remindersData);
      return;
    }

    const updatedReminders = event.data.map(item => ({
      ...item,
      reminderActionIcons: true,

      reminderSubject: item.reminderSubject || item.templateDetails?.templateSubject || '',
      reminderMessage: item.reminderMessage || item.templateDetails?.templateBody || '',
      templateDetails: {
        templateSubject: item.reminderSubject || item.templateDetails?.templateSubject || '',
        templateBody: item.reminderMessage || item.templateDetails?.templateBody || ''
      }
    }));

    this.remindersData = [...this.remindersData, ...updatedReminders];

    this.addMoreReminders.next(this.remindersData);

    this.changeDetectorRef.detectChanges();
  }


  public updateEnabled(toggle) {
    this._QnSbnDataService.setDDToggle(toggle)
  }

  snackBarMessage(status: any, message: string) {
    snackbarService.show({
      message: message,
      snackbarProps: {
        status: status,
        direction: 'horizontal',
        showClose: true,
        elevated: false,
        duration: 5000,
        verticalPlacement: 'top',
        horizontalPlacement: 'right',
      }
    });
  }

  public saveAndClose(): void {

    this.addProduct(this.feedbackDueDate.value, this.remindersData);


    if (this.dialogData) {
      const result = {
        reminders: this.remindersData,
        feedbackDueDate: this.feedbackDueDate.value,
        dueDateEnabled: this.DueDateEnabled,
        feedbackEnabled: this.feedbackEnabled
      };
      this.closeDialog.emit(result);
    }
  }

  public cancelAndClose(): void {

    if (this.dialogData) {
      this.closeDialog.emit(null);
    }
  }

}
